{
	"name": "gbd-branddb-webapp-frontend",
	"version": "2026-11-02 12:00",
	"scripts": {
		"i": "node ./install-dependencies.js",
		"postinstall" : "",
		"assets-cache-busting": "node ./assets-cache-busting.js",
		"dev": "npm run assets-cache-busting && vite",
		"awsdev": "npm run assets-cache-busting && vite build --mode awsdev",
		"awsacc": "npm run assets-cache-busting && vite build --mode awsacc",
		"awsprod": "npm run assets-cache-busting && vite build --mode awsprod",
		"awsdrx": "npm run assets-cache-busting && vite build --mode disasterrecovery",
		"prod-serve": "npm run build-prod && vite preview",
		"prodServe": "npm run prod-serve",
		"build-prod": "npm run assets-cache-busting && vite build --mode production",
		"prod-build": "npm run build-prod",
		"prodBuild": "npm run prod-build",
		"test:e2e": "playwright test",
		"test:e2e:headed": "playwright test --headed",
		"test:e2e:ui": "playwright test --ui"
	},
	"private": true,
	"engines": {
		"node": ">=24 <25"
	},
	"dependencies": {
		"@angular/build": "^22.2.5",
		"@angular/animations": "^22.2.4",
		"@angular/cdk": "^22.2.5",
		"@angular/cli": "^22.2.5",
		"@angular/common": "^22.2.4",
		"@angular/compiler": "^22.2.4",
		"@angular/compiler-cli": "^22.2.4",
		"@angular/core": "^22.2.4",
		"@angular/forms": "^22.2.4",
		"@angular/platform-browser": "^22.2.4",
		"@angular/platform-browser-dynamic": "^22.2.4",
		"@angular/router": "^22.2.4",
		"@fingerprintjs/botd": "^2.0.0",
		"@ngneat/helipopper": "13.1.2",
		"@ngneat/overview": "8.1.0",
		"@ngx-translate/core": "^18.1.0",
		"@ngx-translate/http-loader": "^18.1.0",
		"@types/jest": "^30.0.0",
		"@types/luxon": "^3.7.6",
		"@types/node": "^24.19.2",
		"@wipo/w-angular": "3.7.0",
		"altcha": "^3.5.0",
		"angular-oauth2-oidc": "22.0.2",
		"angular-oauth2-oidc-jwks": "22.0.2",
		"angular2-draggable": "^16.0.0",
		"bson-objectid": "^2.0.4",
		"echarts": "^6.1.0",
		"exceljs": "^4.4.0",
		"express": "^5.3.0",
		"file-saver": "^2.0.5",
		"filenamify": "^7.0.3",
		"glob": "^14.0.3",
		"html2pdf.js": "^0.14.0",
		"jspdf": "^4.2.1",
		"ng-click-outside": "^9.0.1",
		"ng-hcaptcha": "^2.8.0",
		"ngx-echarts": "^22.0.0",
		"primeicons": "^8.0.2",
		"primeng": "^22.1.4",
		"query-string": "^10.0.0",
		"rxjs": "^7.8.2",
		"sanitize-filename": "^1.6.4",
		"ts-node": "^10.9.2",
		"tslib": "^2.9.1",
		"typescript": "6.0.x",
		"zone.js": "^0.16.3",
		"@jsonjoy.com/buffers": "18.30.0",
		"@jsonjoy.com/util": "18.30.0",
		"@jsonjoy.com/json-pack": "18.30.0",
		"electron-to-chromium": "1.5.472",
		"dayjs": "^1.11.23",
		"uuid": "^14.0.3"
	},
	"devDependencies": {
		"@analogjs/vite-plugin-angular": "^2.9.5",
		"@playwright/test": "^1.64.1",
		"@types/chai": "^5.2.3",
		"@types/jasmine": "^7.0.0",
		"@types/jasminewd2": "^2.0.13",
		"chalk": "^6.0.1",
		"codelyzer": "^6.0.2",
		"karma": "^6.4.4",
		"karma-chrome-launcher": "^3.2.0",
		"karma-coverage-istanbul-reporter": "^3.0.3",
		"karma-jasmine": "^5.1.0",
		"karma-jasmine-html-reporter": "^2.3.0",
		"postcss": "^8.5.32",
		"postcss-nesting": "^14.0.3",
		"tslint": "^6.1.3",
		"vite": "^8.3.5",
		"vite-plugin-static-copy": "^4.1.1"
	},
	"overrides": {
		"ansi-regex@^6.2.2": "6.4.0",
		"caniuse-lite": "1.0.30001819",
		"@babel/generator@^7.29.12": "7.29.8",
		"encodeurl@^2.0.0": "2.0.0",
		"node-releases": "2.0.60"
	}
}